export default "__VITE_ASSET__DMqo5SD8__"